import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFHighTemperatureH5, EFLowTemperatureH5, EFElectricPassH5, EFPowerLossH5, EFSaferH5 } from '@/components/UI/svg/mm100';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({ type = 'rv' }: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.kitI} kitI`}>
            <div className="kit-inter1">
                <div className="kit-ms1">{t('presale.product.kitI_inter1_ms1')}</div>
                <div className="kit-ms2">
                    {type === 'rv'
                        ? t(locale === 'kr' ? 'presale.product.kitI_inter1_ms2_rv_h5' : 'presale.product.kitI_inter1_ms2_rv')
                        : t(locale === 'kr' ? 'presale.product.kitI_inter1_ms2_off_grid_h5' : 'presale.product.kitI_inter1_ms2_off_grid')}
                </div>
            </div>
            <div className="kit-inter2">
                <div className="kit-item">
                    <div className="kit-icon">
                        <EFElectricPassH5 width="0.49rem" height="0.49rem" />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter2_ms2')}</div>
                </div>
                <div className="kit-item">
                    <div className="kit-icon">
                        <EFSaferH5 width="0.49rem" height="0.49rem" />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter2_ms1')}</div>
                </div>
                <div className="kit-item kit-item3">
                    <div className="kit-icon">
                        <EFPowerLossH5 width="0.49rem" height="0.49rem" />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter2_ms3')}</div>
                </div>
            </div>
            <div className="kit-inter3">
                <div className="kit-item">
                    <div className="kit-icon">
                        <EFPic name={['KitI1.webp', 'KitI1.jpg']} className="fullImgs" alt={t('presale.product.kitI_inter3_ms1')} />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter3_ms1')}</div>
                    <div className="kit-temperature">
                        <EFHighTemperatureH5 width="0.25rem" height="0.34rem" />
                    </div>
                </div>
                <div className="kit-item">
                    <div className="kit-icon">
                        <EFPic name={['KitI2.webp', 'KitI2.jpg']} className="fullImgs" alt={t('presale.product.kitI_inter3_ms2')} />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter3_ms2')}</div>
                    <div className="kit-temperature">
                        <EFLowTemperatureH5 width="0.21rem" height="0.34rem" />
                    </div>
                </div>
            </div>
        </div>
    );
}
